import { useEffect, useState } from "react";
import DropDown from "../../../../Filters/DropDown";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { Input } from "../../../../Input/Input";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";
import styled from "styled-components";
import { makeNetfMemberPw } from "../../../../../scCommon/scCommonFunc";

interface Props extends DefaultModalCommonProps {
  partyId: number;
  uid: number;
  email: string;
  linkidmail?: string;
}

export default function NetflixExtraPwResetModal({
  closeEvent,
  partyId,
  uid,
  email,
  linkidmail,
}: Props) {
  const [reset, setReset] = useState(false);
  const [password, setPassword] = useState("");
  const [editType, setEditType] = useState({
    value: "",
    label: "선택",
  });

  const { response, loading, error } = useApi({
    method: "post",
    url: reset ? `party/light` : undefined,
    data: {
      email,
      pw: password,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("비밀번호가 업데이트 되었습니다.");
      closeEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "비밀번호 재설정에 실패했습니다.");
    }
  }, [error]);

  // const postReset = () => {
  //   const body = {
  //     id: id,
  //     pw: pw,
  //   };

  //   const addr = `${LOGIN_CHECKER_DOMAIN}/logincheck_Realclass`;

  //   try {
  //     const res = await axios.post(addr, body);
  //     console.log("✅ success: ", res);

  //     return res.data.data;
  //   } catch (error) {
  //     console.log("🚨 error: ", error);
  //     console.log(error.response);
  //     return false;
  //   }
  // };

  return (
    <DefaultModalLayout
      closeEvent={closeEvent}
      confirmEvent={() => {
        let pw = "";
        if (editType.value === "auto") {
          // pw = "3";
          pw = makeNetfMemberPw().pw;
        } else {
          pw = password;
        }
        // setReset(true);

        console.log("재설정 매크로", pw, email, reset);
      }}
      isMediumModal
      modalTitle="비밀번호 재설정"
      confirmDisabled={
        editType.value === "" ||
        // editType.value === "auto" ||
        (editType.value === "custom" ? password === "" : false)
      }
    >
      <ModalRow>
        <ModalLabel>편집 방식</ModalLabel>

        <ModalRowContentContainer>
          <DropDown
            optionList={[
              { value: "auto", label: "자동 재설정" },
              { value: "custom", label: "직접 입력" },
            ]}
            dropdownValue={editType}
            setDropDownValue={setEditType}
          />
        </ModalRowContentContainer>
      </ModalRow>

      <>
        {editType.value === "custom" && (
          <ModalRow style={{ alignItems: "flex-start" }}>
            <ModalLabel>비밀번호 입력</ModalLabel>

            <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
              <Input
                placeholder="비밀번호를 입력해 주세요1111"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Desc>
                - 영문 대소문자, 숫자, 기호를 조합한 비밀번호를 권장해요. <br />
                - 6~60자 사이의 비밀번호를 입력해 주세요. <br />- 이전에
                사용했던 비밀번호는 입력할 수 없어요. <br />- 안전하지 않거나
                너무 흔한 비밀번호는 입력할 수 없어요. <br />
                (예. abcdefgh, 12345678, password123, aabbccdd 등)
              </Desc>
            </ModalRowContentContainer>
          </ModalRow>
        )}

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}

const Desc = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: #858c97;
  line-height: 1.85;
`;
